import Sentence from './Sentence';

export default class VirtualPackReimbursement {
	id: string;

	distinctName: string;

	sentences: Sentence[];

	constructor(id: string, distinctName: string, sentences: Sentence[]) {
		this.id = id;
		this.distinctName = distinctName;
		this.sentences = sentences;
	}

	hasSimilarSentences(otherSentences: Sentence[]): boolean {
		if (this.sentences.length !== otherSentences.length) {
			return false;
		}
		return this.sentences.find((sentence, i) => !sentence.isSimilar(otherSentences[i])) === undefined;
	}
}
